import React from 'react';
import { SignInPage } from 'src/pages/SignInPage/SignInPage/SignInPage';

export const GreetingsPage: React.FC = () => {
	return <SignInPage />;
};
